import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import {
  getNumbersAfterEditCamera,
  getNumbersAfterSites,
} from "../../EditCamera/EditCamera";
import { addIgnoreLabel } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/addIgnoreLabel";
import { IgnoreZone } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { resizeImageIgnoreZones } from "../../EditIgnoreZones/EditIgnoreZonesUtils/resizeImageIgnoreZones";
import { adjustDimensionsFromFrame } from "./coordinateTransforms";

export interface NewIgnoreZonesPageData {
  previewUrl: string;
  cameraName: string;
  dimensions: { width: number; height: number };
  adjustedDimensions: { x: number; y: number };
  breadcrumbs: string[];
  apiRows: IgnoreZone[];
}

export const fetchNewIgnoreZonesPageData = async (): Promise<NewIgnoreZonesPageData> => {
  const AxiosUI = createApi("");
  const cameraId = getNumbersAfterEditCamera(location.href);
  const siteId = getNumbersAfterSites(location.href);

  const statusResponse: AxiosResponse = await AxiosUI.get(
    `/camera/${cameraId}/status/`
  );
  const dimensions = resizeImageIgnoreZones(statusResponse.data.frame_dimensions);
  const adjustedDimensions = adjustDimensionsFromFrame(
    statusResponse.data.frame_dimensions
  );
  const previewUrl = statusResponse.data.preview_url;
  let cameraName = statusResponse.data.camera_name as string;

  const ignoreZonesResponse: AxiosResponse = await AxiosUI.get(
    `/camera/${cameraId}/ignore_zones/`
  );
  const apiRows = addIgnoreLabel(ignoreZonesResponse.data) as IgnoreZone[];

  const aboutResponse: AxiosResponse = await AxiosUI.get(
    `customer/${siteId}/about/`
  );

  if (!cameraName) {
    const generalInfoResponse: AxiosResponse = await AxiosUI.get(
      `/camera/${cameraId}/general_info/`
    );
    cameraName = generalInfoResponse.data.camera_name;
  }

  return {
    previewUrl,
    cameraName,
    dimensions,
    adjustedDimensions,
    breadcrumbs: aboutResponse.data.breadcrumbs,
    apiRows,
  };
};

export const isFetchError = (error: unknown): error is AxiosError =>
  (error as AxiosError)?.isAxiosError === true;
